import * as actionTypes from '../actions/actionTypes';

const initialState = {
  summary: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ENREGISTRER_ACCUEIL_SUMMARY:
      return { ...state, summary: action.summary || null };
    default:
      return state;
  }
};

export default reducer;
